exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 501px) {\n.show-whatsapp-mobile {\n    display: none;\n}\n}\n@media screen and (max-width: 500px) {\n.show-whatsapp-desktop {\n    display: none;\n}\n}\n@media (min-width: 959px) and (max-width: 1904px) {\n.container {\n    max-width: 1400px;\n}\n}", ""]);

// exports
